"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;
var _vue = require("vue");
var _projectCover = _interopRequireDefault(require("@/assets/images/project-cover.png"));
var _warning = _interopRequireDefault(require("@/assets/images/warning.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const _withScopeId = n => ((0, _vue.pushScopeId)("data-v-72a5b5f2"), n = n(), (0, _vue.popScopeId)(), n);
const _hoisted_1 = {
  ref: "createCreative"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "cover"
}, [/*#__PURE__*/(0, _vue.createElementVNode)("img", {
  src: _projectCover.default,
  alt: ""
})], -1 /* HOISTED */));
const _hoisted_4 = {
  class: "form"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "form_tit"
}, "创建项目组", -1 /* HOISTED */));
const _hoisted_6 = {
  class: "row jc-between ai-center"
};
const _hoisted_7 = {
  class: "band_name"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "title"
}, "品牌名称", -1 /* HOISTED */));
const _hoisted_9 = {
  class: "project_name"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "title"
}, "项目名称", -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "title"
}, "项目期限", -1 /* HOISTED */));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "title"
}, "项目需求", -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("div", {
  class: "title"
}, "项目成员", -1 /* HOISTED */));
const _hoisted_14 = {
  key: 0,
  class: "warning row ai-center"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0, _vue.createElementVNode)("img", {
  src: _warning.default,
  alt: ""
}, null, -1 /* HOISTED */));

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = (0, _vue.resolveComponent)("Input");
  const _component_DatePicker = (0, _vue.resolveComponent)("DatePicker");
  const _component_Button = (0, _vue.resolveComponent)("Button");
  const _component_Modal = (0, _vue.resolveComponent)("Modal");
  return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [(0, _vue.createVNode)(_component_Modal, {
    "class-name": "create-project-dialog",
    getContainer: () => _ctx.$refs.createCreative,
    "model-value": $props.show,
    width: "916",
    transfer: false,
    "mask-closable": false,
    onOnVisibleChange: $options.onVisibleChange
  }, {
    footer: (0, _vue.withCtx)(() => [(0, _vue.createVNode)(_component_Button, {
      type: "text",
      onClick: $options.cancel
    }, {
      default: (0, _vue.withCtx)(() => [(0, _vue.createTextVNode)("取消")]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"]), (0, _vue.createVNode)(_component_Button, {
      type: "primary",
      class: "btn",
      loading: $props.loading,
      onClick: $options.submit
    }, {
      default: (0, _vue.withCtx)(() => [(0, _vue.createTextVNode)("申请项目积分")]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading", "onClick"])]),
    default: (0, _vue.withCtx)(() => [(0, _vue.createElementVNode)("div", _hoisted_2, [_hoisted_3, (0, _vue.createElementVNode)("div", _hoisted_4, [_hoisted_5, (0, _vue.createElementVNode)("div", _hoisted_6, [(0, _vue.createElementVNode)("div", _hoisted_7, [_hoisted_8, (0, _vue.createVNode)(_component_Input, {
      clearable: "",
      modelValue: $data.formValidate.brand_name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formValidate.brand_name = $event),
      placeholder: "请输入品牌名称",
      style: {
        "width": "180px"
      }
    }, null, 8 /* PROPS */, ["modelValue"])]), (0, _vue.createElementVNode)("div", _hoisted_9, [_hoisted_10, (0, _vue.createVNode)(_component_Input, {
      clearable: "",
      modelValue: $data.formValidate.project_name,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formValidate.project_name = $event),
      placeholder: "请输入项目名称",
      style: {
        "width": "180px"
      }
    }, null, 8 /* PROPS */, ["modelValue"])])]), (0, _vue.createElementVNode)("div", null, [_hoisted_11, (0, _vue.createVNode)(_component_DatePicker, {
      modelValue: $data.timeDate,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.timeDate = $event),
      format: "yyyy/MM/dd",
      type: "daterange",
      placement: "bottom-end",
      placeholder: "yyyy/mm/dd | yyyy/mm/dd",
      onOnChange: $options.dateFormat,
      style: {
        "width": "300px"
      }
    }, null, 8 /* PROPS */, ["modelValue", "onOnChange"])]), (0, _vue.createElementVNode)("div", null, [_hoisted_12, (0, _vue.createVNode)(_component_Input, {
      type: "textarea",
      rows: 2,
      modelValue: $data.formValidate.usage,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formValidate.usage = $event),
      placeholder: "请描述使用imagine的具体用途，例如：\n创作小红书文案和配图",
      style: {
        "height": "62px"
      }
    }, null, 8 /* PROPS */, ["modelValue"])]), (0, _vue.createElementVNode)("div", null, [_hoisted_13, (0, _vue.createVNode)(_component_Input, {
      type: "textarea",
      rows: 4,
      modelValue: $data.formValidate.members,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formValidate.members = $event),
      onOnChange: $options.validateEmails,
      placeholder: "可输入多个邮箱，请用换行隔开，例如:\njohn.hu@wpp.com\nmay.xu@ogilvy.com\njudy.wang@groupm.com"
    }, null, 8 /* PROPS */, ["modelValue", "onOnChange"]), $data.invalidEmails.length > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_14, [_hoisted_15, (0, _vue.createElementVNode)("span", null, [(0, _vue.createTextVNode)("以下邮箱存在格式异常，请检查： "), ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)(_vue.Fragment, null, (0, _vue.renderList)($data.invalidEmails, email => {
      return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
        key: email
      }, (0, _vue.toDisplayString)(email), 1 /* TEXT */);
    }), 128 /* KEYED_FRAGMENT */))])])) : (0, _vue.createCommentVNode)("v-if", true)])])])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["getContainer", "model-value", "onOnVisibleChange"])], 512 /* NEED_PATCH */);
}